import { render, staticRenderFns } from "./distributorInfo.vue?vue&type=template&id=a449bb44&scoped=true"
import script from "./distributorInfo.vue?vue&type=script&lang=js"
export * from "./distributorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a449bb44",
  null
  
)

export default component.exports